'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _lib = require('@alicd/next/lib/_components/@alicd/next-util/lib');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _datePickTool = require('./module/date-pick-tool');

var _datePickTool2 = _interopRequireDefault(_datePickTool);

var _calendarTable = require('./table/calendar-table');

var _calendarTable2 = _interopRequireDefault(_calendarTable);

var _calendarMixin = require('./calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerPanel = function (_Component) {
    (0, _inherits3.default)(DatePickerPanel, _Component);

    function DatePickerPanel(props, context) {
        (0, _classCallCheck3.default)(this, DatePickerPanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DatePickerPanel.__proto__ || (0, _getPrototypeOf2.default)(DatePickerPanel)).call(this, props, context));

        _this.state = {
            base: props.base ? (0, _moment2.default)(props.base) : (0, _moment2.default)(),
            value: (0, _util.normalizeWeekday)(props.value ? (0, _moment2.default)(props.value) : (0, _moment2.default)(), props.selectWeek),
            mode: props.mode,
            animate: false
        };
        return _this;
    }

    (0, _createClass3.default)(DatePickerPanel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('base' in newProps) {
                this.setState({
                    base: newProps.base ? (0, _moment2.default)(newProps.base) : (0, _moment2.default)()
                });
            }

            if ('value' in newProps) {
                this.setState({
                    value: (0, _util.normalizeWeekday)(newProps.value ? (0, _moment2.default)(newProps.value) : (0, _moment2.default)(), newProps.selectWeek)
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(needChange, nextState) {
            var base = nextState.base,
                mode = nextState.mode;


            if (needChange) {
                this.setState({
                    base: base,
                    mode: mode
                });
            }

            // Important: 兼容 0.x BR
            if (mode === 'date' && this.props.onSelect) {
                _lib.log.deprecated('onSelect', 'onChange', 'Calendar.DatePickerPanel');
                this.props.onSelect(base);
            }

            this.props.onChange(nextState);
        }
    }, {
        key: 'onAnimate',
        value: function onAnimate(animate) {
            var _this2 = this;

            this.setState({
                animate: animate
            });

            setTimeout(function () {
                _this2.setState({
                    animate: false
                });
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                className = _props.className,
                others = (0, _objectWithoutProperties3.default)(_props, ['className']);

            var prefix = this.context.prefix || others.prefix;
            var _state = this.state,
                base = _state.base,
                value = _state.value,
                mode = _state.mode,
                animate = _state.animate;


            var calendarCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-card', true), (0, _defineProperty3.default)(_classNames, className, className), _classNames));
            var calendarBodyCls = (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, prefix + 'calendar-body', true), (0, _defineProperty3.default)(_classNames2, '' + animate, animate), _classNames2));

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, (0, _lib.pickAttrs)(others), { className: calendarCls, ref: 'date-picker-panel' }),
                _react2.default.createElement(
                    'div',
                    { className: prefix + 'calendar-header' },
                    _react2.default.createElement(_datePickTool2.default, (0, _extends3.default)({}, others, { base: base, mode: mode, onChange: this.onChange.bind(this, true), onAnimate: this.onAnimate.bind(this) }))
                ),
                _react2.default.createElement(
                    'div',
                    { className: calendarBodyCls },
                    _react2.default.createElement(_calendarTable2.default, (0, _extends3.default)({}, others, { type: 'card', base: base, value: value, mode: mode, onChange: this.onChange.bind(this, false) }))
                )
            );
        }
    }]);
    return DatePickerPanel;
}(_react.Component);

DatePickerPanel.propTypes = {
    onChange: _propTypes2.default.func,
    className: _propTypes2.default.string,
    selectWeek: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool])
};
DatePickerPanel.defaultProps = {
    mode: 'month',
    onChange: function onChange() {}
};
DatePickerPanel.contextTypes = {
    prefix: _propTypes2.default.string
};


(0, _calendarMixin2.default)(DatePickerPanel);

exports.default = (0, _localeProvider2.default)(DatePickerPanel);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/date-picker-panel.js
// module id = 269
// module chunks = 0